import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import {RouterModule} from '@angular/router';

import { AppComponent } from './app.component';
import { ContactComponent } from './contact/contact.component';
import { CasestudyComponent } from './casestudy/casestudy.component';
import { FeaturesComponent } from './features/features.component';
import { ProcessComponent } from './process/process.component';


@NgModule({
  declarations: [
    AppComponent,
    ContactComponent,
    CasestudyComponent,
    FeaturesComponent,
    ProcessComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(
      [
        { path: 'casestudy', component: CasestudyComponent },
        { path: 'casestudy/*', redirectTo: '/casestudy' }
      ]
    )
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/jacobvarghese/git/matchiq-web/matchiq/src/app/app.module.ts